var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2869_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 37,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 38,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2869_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -1,
    width: 65,
    height: 45,
    fill: "#908F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2869_8",
    transform: "matrix(0.00401182 0 0 0.00390625 -0.0135135 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2869_8",
    width: 256,
    height: 256,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.1714db50f86dbaa88f5a4193fb5ccb7f.svg";
export { ForwardRef as ReactComponent };